export default __webpack_public_path__ + "static/media/tutoring1.f96732f3.svg";